import { useEffect } from "react";
import type { AgentRunStatus } from "@/stores/devAgentStore";

export function useDevAgentShortcuts(params: {
  runStatus: AgentRunStatus;
  handleStop: () => void;
  setSidebarCollapsed: (fn: (value: boolean) => boolean) => void;
}) {
  const { runStatus, handleStop, setSidebarCollapsed } = params;

  useEffect(() => {
    const handler = (event: KeyboardEvent) => {
      if (event.key === "Escape" && runStatus === "running") {
        event.preventDefault();
        handleStop();
      }
      if ((event.metaKey || event.ctrlKey) && event.key === "k") {
        event.preventDefault();
        document.querySelector<HTMLTextAreaElement>("[data-agent-input]")?.focus();
      }
      if ((event.metaKey || event.ctrlKey) && event.key === "/") {
        event.preventDefault();
        setSidebarCollapsed((collapsed: boolean) => !collapsed);
      }
    };

    window.addEventListener("keydown", handler);
    return () => window.removeEventListener("keydown", handler);
  }, [runStatus, handleStop, setSidebarCollapsed]);
}
